import r, { css as i } from "styled-components";
import { Button as s } from "../../Button/Button.js";
import { device as e } from "../../../utils/device.js";
const l = r.div`
  padding-top: 64px;

  @media ${e.isDesktop}, ${e.isTablet} {
    display: flex;
    justify-content: ${(t) => t.order === "ascending" ? "flex-end" : "flex-start"};
    align-items: flex-end;
    flex-grow: 1;
    flex-direction: ${(t) => t.order === "ascending" ? "row" : "row-reverse"};
  }

  @media ${e.isMobile} {
    display: flex;
    flex-direction: ${(t) => t.order === "ascending" ? "column-reverse" : "column"};
    padding-bottom: 12px;
  }

  @media ${e.isDesktop} {
    padding-right: 32px;
  }
`, n = i``, a = i`
  @media ${e.isMobile} {
    margin-top: 20px;
  }
  @media ${e.isDesktop}, ${e.isTablet} {
    margin-right: 20px;
  }
`, d = i`
  @media ${e.isMobile} {
    margin-top: 20px;
  }
  @media ${e.isDesktop}, ${e.isTablet} {
    margin-right: 20px;
  }
`, x = r(s)`
  ${(t) => {
  const { buttonType: o } = t;
  switch (o) {
    case "secondary":
      return a;
    case "tertiary":
      return d;
    case "primary":
    default:
      return n;
  }
}}
`;
export {
  l as Container,
  x as NavButton
};
